import ZipCode from '@/components/simulation/questions/ZipCode.vue';
import Consumption from '@/components/simulation/questions/Consumption.vue';
import FuelConsumption from '@/components/simulation/questions/FuelConsumption.vue';
import WoodConsumption from '@/components/simulation/questions/WoodConsumption.vue';
import ElectricityConsumption from '@/components/simulation/questions/ElectricityConsumption.vue';
import ConsumptionKnown from '@/components/simulation/questions/ConsumptionKnown.vue';
import Energy from '@/components/simulation/questions/Energy.vue';
import Building from '@/components/simulation/questions/Building.vue';
import BuildingDate from '@/components/simulation/questions/BuildingDate.vue';
import BuildingType from '@/components/simulation/questions/BuildingType.vue';
import Mobility from '@/components/simulation/questions/Mobility.vue';

export function zipCode(simulation) {
  return {
    component: ZipCode,
    done: () => {
      return simulation.cityIndex !== null;
    },
  };
}

export function consumption(simulation) {
  return {
    component: Consumption,
    done: () => {
      return simulation.consumption;
    },
  };
}

export function energy(simulation) {
  return {
    component: Energy,
    done: () => {
      return simulation.energy;
    },
  };
}

export function consumptionKnown(simulation) {
  return {
    component: ConsumptionKnown,
    done: () => {
      return simulation.consumptionKnown !== null;
    },
  };
}

export function consumptionWithPower(simulation) {
  return {
    component: Consumption,
    done: () => {
      return simulation.consumption && simulation.power;
    },
    context: {
      withPower: true,
    },
  };
}

export function fuelConsumption(simulation) {
  return {
    component: FuelConsumption,
    done: () => {
      return simulation.fuelConsumption;
    },
  };
}

export function woodConsumption(simulation) {
  return {
    component: WoodConsumption,
    done: () => {
      return simulation.woodConsumption;
    },
  };
}

export function electricityConsumption(simulation) {
  return {
    component: ElectricityConsumption,
    done: () => {
      return simulation.consumption;
    },
  };
}

export function mobility(simulation) {
  return {
    component: Mobility,
    done: () => {
      return simulation.mobilityConsumption && simulation.distance;
    },
  };
}

export function building(simulation) {
  return {
    component: Building,
    done: () => {
      return (
        simulation.buildingUsage &&
        (simulation.city || simulation.buildingAltitude)
      );
    },
  };
}

export function buildingDate(simulation) {
  return {
    component: BuildingDate,
    done: () => {
      return simulation.buildingDate;
    },
  };
}

export function buildingType(simulation) {
  return {
    component: BuildingType,
    done: () => {
      return simulation.buildingType;
    },
  };
}
